export default __webpack_public_path__ + "static/rsa_lotto_plus_2-a322ab4910273d2d5c975444f398026b.png";